window.PmsAPI = new (function () {

    const self = this;
    const _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.getBaseAPI("PMS"));

    self.getPMSGeneralSettings = (brandId) => {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/settings`, 'GET')
            .then((res) => {

                if (res.data?.data?.settings) {
                    deferred.resolve(res.data.data.settings);
                } else {
                    deferred.reject(res);
                }
            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPMSManagementBrandId = async (brandId) => {
        const result = await _protected.request(`brands/${brandId}/management_brand`, 'GET');
        if (result.data?.data && result.status === 200) {
            return result.data.data.management_brand.id;
        }
        throw result;
    };

    self.getBusinessBrandSettings = cacheService.cache(async (brandId) => {
        const result = await _protected.request(`businesses/${brandId}/settings`, 'GET');
        if (result.data?.data && result.status === 200) {
            return result.data.data.settings;
        }
        throw result;
    })[0];

    self.addBusinessSecondApprovals = async (brandId, title, brands) => {
        let params = {};

        params.title = title;
        params.brands = brands;

        const result = await _protected.request(`businesses/${brandId}/settings/second_approvals`, 'POST', params);
        if (result.data?.data && [200, 201].includes(result.status)) {
            return result.data.data;
        }
        throw result;
    };

    self.updateBusinessSecondApprovals = async (brandId, secondApprovalFlowId, title, brands) => {
        let params = {};

        params.title = title;
        params.brands = brands;

        const result = await _protected.request(`businesses/${brandId}/settings/second_approvals/${secondApprovalFlowId}`, 'PUT', params);
        if (result.data?.data && [200, 201].includes(result.status)) {
            return result.data.data;
        }
        throw result;
    };

    self.getBusinessSecondApprovals = async (brandId) => {
        const result = await _protected.request(`businesses/${brandId}/settings/second_approvals`, 'GET');
        if (result.data?.data && result.status === 200) {
            return result.data.data.second_approvals;
        }
        throw result;
    };

    self.getBusinessSecondApprovalFlow = async (brandId, flowId) => {
        const result = await _protected.request(`businesses/${brandId}/settings/second_approvals/${flowId}`, 'GET');
        if (result.data?.data && result.status === 200) {
            return result.data.data.second_approval;
        }
        throw result;
    };

    self.deleteBusinessSecondApproval = async (brandId, secondApprovalFlowId) => {
        const result = await _protected.request(`businesses/${brandId}/settings/second_approvals/${secondApprovalFlowId}`, 'DELETE');
        if (result.data?.data && result.status === 200) {
            return result.data.data;
        }
        throw result;
    };
});
